import { type TokenProvider } from '@/app/providers/SsoTokenProvider';

let globalTokenProvider: TokenProvider | null = null;
export function setGlobalTokenProvider(provider: TokenProvider) {
  globalTokenProvider = provider;
}

export function getGlobalTokenProvider(): TokenProvider | null {
  return globalTokenProvider;
}

/**
 * 토큰 갱신 시도 (단일 Promise 공유)
 *
 * - 동시 다발 401에서 호출되어도 provider.getToken()은 1회만 실행
 * - 성공 시 새 토큰 문자열 반환
 * - 실패 시 null 반환
 * - 토큰 저장, 이벤트 발행, UI 상태 변경은 호출자(인터셉터)가 담당
 */
let pendingRefresh: Promise<string | null> | null = null;

export async function refreshToken(): Promise<string | null> {
  if (pendingRefresh) {
    return pendingRefresh;
  }

  pendingRefresh = doRefresh();
  try {
    return await pendingRefresh;
  } finally {
    pendingRefresh = null;
  }
}

async function doRefresh(): Promise<string | null> {
  if (!globalTokenProvider) {
    console.warn('[refreshToken] globalTokenProvider 미설정 — 토큰 갱신 불가');
    return null;
  }
  try {
    const newToken = await globalTokenProvider.getToken();
    if (newToken) {
      return newToken;
    }
    console.warn('[refreshToken] provider가 빈 토큰 반환');
    return null;
  } catch (err) {
    console.warn(
      '[refreshToken] 토큰 갱신 실패:',
      err instanceof Error ? err.message : String(err),
    );
    return null;
  }
}
